/* eslint-disable react/style-prop-object */
import React from 'react';
import { Button, Flex, Text, View } from '@adobe/react-spectrum';
import { captureImage } from 'app/stores/image/actions/capture';
import { useAppDispatch } from 'app/stores/store';
import { hasMediaDevices } from 'app/utils/caniuse';
export const Capture = (props) => {
    const { onSelect } = props;
    const dispatch = useAppDispatch();
    const capture = React.useCallback(() => {
        dispatch(captureImage()).then(onSelect);
    }, [onSelect, dispatch]);
    return (React.createElement(View, { padding: "size-150", borderColor: "gray-200", borderWidth: "thin", borderRadius: "medium", gridArea: "right" },
        React.createElement(Flex, { direction: "column", gap: "size-150" },
            React.createElement(Text, null, "Capture screenshot of your screen or a specific window"),
            React.createElement(Button, { isDisabled: !hasMediaDevices(), variant: "secondary", style: "outline", onPress: capture }, "Capture screen"))));
};
